import axios from 'axios';

import { ResponseObj, ResultadoDeExameFormData, ResultadoExameSoftDeleteFormData } from '../../../back/src/types';
import { ResultadoDeExame } from '../../../back/src/entity/ResultadoDeExame';

const atualizaResultadoExame = async (
  formData: ResultadoDeExameFormData,
): Promise<ResponseObj<ResultadoDeExame>> => {
  const res = await axios.put<ResponseObj<ResultadoDeExame>>(
    'resultados_de_exames',
    formData,
  );
  return res.data;
};

const criaResultadoExame = async (
  formData: ResultadoDeExameFormData,
): Promise<ResponseObj<ResultadoDeExame>> => {
  const res = await axios.post<ResponseObj<ResultadoDeExame>>('resultados_de_exames', formData);
  return res.data;
};

const criaResultadoExameBulk = async (
  formData: ResultadoDeExameFormData[],
): Promise<ResponseObj<ResultadoDeExame[]>> => {
  const res = await axios.post<ResponseObj<ResultadoDeExame[]>>('resultados_de_exames/bulk', formData);
  return res.data;
};

const removeResultadoExame = async (
  resultadoId: number,
  formData: ResultadoExameSoftDeleteFormData,
): Promise<ResponseObj<ResultadoDeExame>> => {
  const res = await axios.put<ResponseObj<ResultadoDeExame>>(`resultados_de_exames/remover/${resultadoId}`, formData);
  return res.data;
};

const restauraResultadoExame = async (
  resultadoId: number,
  formData: ResultadoExameSoftDeleteFormData,
): Promise<ResponseObj<ResultadoDeExame>> => {
  const res = await axios.put<ResponseObj<ResultadoDeExame>>(`resultados_de_exames/restaurar/${resultadoId}`, formData);
  return res.data;
};

export default {
  atualizaResultadoExame,
  criaResultadoExame,
  criaResultadoExameBulk,
  removeResultadoExame,
  restauraResultadoExame,
};
